export default __webpack_public_path__ + "2a35e1477ac17a9a78aeac15c65c74f3.png";